import { Code } from '../models/code';
import { Paths } from '../models/paths';
import { Syzkaller } from '../models/syzkaller';
import { Snippets } from '../views/snippets/snippets';
import { Navigation } from '../views/navigation/navigation';
import { Dialog } from '../views/dialog/dialog';
export class Reachability {
    constructor(index, codePromise, pathsPromise, syzkallerPromise) {
        this.index = index;
        this.codePromise = codePromise;
        this.pathsPromise = pathsPromise;
        this.syzkallerPromise = syzkallerPromise;
        this.snippets = new Snippets(this);
        this.navigation = new Navigation(this);
        this.dialog = new Dialog(this);
        this.syscalls = new Set;
    }
    async onLocationChange(locationHash) {
        let identifier = locationHash.slice(1);
        let [$file_path, $start_line, $end_line] = identifier.split(':');
        await Promise.all([
            this.snippets.displayLoading(identifier),
            this.navigation.initNavigation(),
            this.loadAllSyscalls(),
            this.showFileLine(await Snippets.getRootNode(), $file_path, Number($start_line), Number($end_line), identifier)
        ]);
    }
    static async init(index) {
        const reachability = new Reachability(index, Promise.resolve().then(() => Code.init(reachability.snippets)), Promise.resolve().then(() => Paths.init()), Promise.resolve().then(() => Syzkaller.init()));
        return reachability;
    }
    async showFileLine(parentNode, $file_path, $start_line, $end_line, title = "", arrowSource = null) {
        let promise = this.showFileLineInternal(parentNode, $file_path, $start_line, $end_line, title, arrowSource);
        if (parentNode.style) {
            parentNode.style.cursor = 'progress';
            await promise;
            parentNode.style.cursor = '';
        }
        return promise;
    }
    async showFileLineInternal(parentNode, $file_path, $start_line, $end_line, title, arrowSource) {
        const code = await this.codePromise;
        const paths = await this.pathsPromise;
        const syzkaller = await this.syzkallerPromise;
        // end_line = 0 means it is the same as start_line
        $end_line = $end_line || $start_line;
        const coverage = syzkaller.getCoverageByFileLine($file_path, $start_line, $end_line);
        const childEdges = paths.getChildEdgesByFileLine($file_path, $start_line, $end_line);
        const parentEdges = paths.getParentEdgesByFileLine($file_path, $start_line, $end_line);
        const syzkalls = syzkaller.getSyscallsByFileLine($file_path, $start_line, $end_line);
        const syscalls = paths.getSyscallsByFileLine($file_path, $start_line, $end_line);
        const conditions = paths.getConditionsByFileLine($file_path, $start_line, $end_line);
        const linesOfCode = await code.getSourceByFileLine($file_path, $start_line, $end_line);
        if (linesOfCode.length == 0) {
            console.log('No code found for', $file_path, $start_line, $end_line);
            return;
        }
        let snippet = await this.snippets.displaySnippet(parentNode, $file_path, linesOfCode.map(loc => loc.data), linesOfCode[0].line_no, title, childEdges, parentEdges, coverage, syscalls, syzkalls, conditions);
        if (arrowSource) {
            this.navigation.addLine(arrowSource, snippet);
        }
        this.updateViews();
        console.log(await Promise.all([
            'loc', linesOfCode, 'cov', coverage,
            'chi', childEdges, 'par', parentEdges,
            'sys', syscalls, 'syz', syzkalls
        ]));
    }
    async displaySyzkallerPrograms(programs) {
        let syzkaller = await this.syzkallerPromise;
        this.dialog.displaySyzkallerPrograms(await Dialog.getRootNode(), await syzkaller.getProgramById(programs));
    }
    async displayConditions(conditions) {
        this.dialog.displayConditions(await Dialog.getRootNode(), conditions);
    }
    async displayEdgeSelection(functionName, filePath, lineNumber, node, childEdges) {
        const paths = await this.pathsPromise;
        const allEdges = await paths.getAllEdgesFromFileLine(filePath, lineNumber);
        this.dialog.displayEdgeSelection(await Dialog.getRootNode(), allEdges, functionName, node, childEdges);
    }
    async loadAllSyscalls() {
        let syzkaller = await this.syzkallerPromise;
        let paths = await this.pathsPromise;
        [
            ...(await syzkaller.getAllSyscalls()),
            ...(await paths.getAllSyscalls())
        ].forEach(row => this.syscalls.add(row.syscall));
        let syscalls = this.syscalls.values();
        this.snippets.createSyscallFilters([...syscalls]);
    }
    updateViews() {
        this.navigation.updateLinesPositions();
    }
}
